import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import Loader from '../components/loader.jsx';
import EmbedLink from '../components/embed_link.jsx';
import EmbedLTI from '../components/embed_lti.jsx';
import EmbedLTI1p3 from '../components/embed_lti1p3.jsx';
import { getLastPageRead } from '../actions/content';
import connect from '../components/connect';
import { createLoader } from '../loader';
import { routeToContentPage, routeToHome } from '../actions/route';

import { contentResource, lastPageResource } from '../resources/content';

function extractMediaType(content) {
    const { launch_params, embed_html } = content;
    let { media_type } = content;

    // Some links aren't links. YAY! for legacy logic!
    if (media_type === 'link') {
        if (launch_params != null) {
            media_type = 'lti_link';
        }

        if (embed_html !== '') {
            media_type = 'embedded_link';
        }
    }

    return media_type;
}

class Content extends React.Component {
    static displayName = 'Content';

    static propTypes = {
        routeToContentPage: PropTypes.func.isRequired,
        getLastPageRead: PropTypes.func.isRequired,
        content: PropTypes.any,
        children: PropTypes.element,
        routeToHome: PropTypes.func.isRequired,
        params: PropTypes.shape({
            contentId: PropTypes.string.isRequired,
        }).isRequired,
        lastPageRead: PropTypes.any,
    };

    componentDidMount() {
        $('body').addClass('embedded-content');
    }

    componentWillUnmount() {
        $('body').removeClass('embedded-content');
    }

    UNSAFE_componentWillMount() {
        if (!this.props.content.id) {
            this.props.routeToHome({
                routeType: 'replace',
            });
        }
    }

    render() {
        const { content, lastPageRead } = this.props;
        const media_type = extractMediaType(content);

        switch (media_type) {
            case 'embedded_link':
                return <EmbedLink content={content} />;
            case 'lti1p3_link':
                return <EmbedLTI1p3
                           content={content}
                           slug={content.slug}
                       />;
            case 'lti_link':
                return <EmbedLTI content={content} key={content.id} />;
            case 'text':
                if (this.props.children) {
                    return this.props.children;
                }

                this.props.routeToContentPage({
                    routeType: 'replace',
                    contentId: content.id,
                    pagenum: lastPageRead,
                });

            // falls through
            case undefined:
                return <Loader message="Loading content..." />;
            default:
                throw new Error('Unrecognized media_type: ' + media_type);
        }
    }
}

const ContentLoader = createLoader({
    renderBusy() {
        return <Loader message="Loading content..." />;
    },
    component: Content,
    resources: {
        content(options) {
            const contentId = parseInt(options.props.params.contentId, 10);
            return contentResource(contentId, options);
        },
        lastPageRead: {
            // for offline
            depends: ['content'],
            lastPageRead: lastPageResource,
        },
    },
});

const mapStateToProps = state => ({ rootState: state });

export default connect(
    mapStateToProps,
    {
        getLastPageRead,
        routeToContentPage,
        routeToHome,
    },
    null,
    { pure: true }
)(ContentLoader);



// WEBPACK FOOTER //
// ./src/controllerviews/content.jsx